import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
const ComposerLoadingOverlay = () => {
  return /*#__PURE__*/_jsx(UILoadingOverlay, {
    contextual: true,
    showLabel: true,
    layout: "centered"
  });
};
ComposerLoadingOverlay.displayName = 'ComposerLoadingOverlay';
export default ComposerLoadingOverlay;